var rules = function(width, height, margin) {
    this.margin = margin;
    this.width = width - this.margin.left - this.margin.right;
    this.height = height - this.margin.top - this.margin.bottom;
    this.interval = [
        [0, 0],
        [Math.floor(graph.pixelToMM(this.width) / 1000), Math.floor(graph.pixelToMM(this.height) / 1000)]
    ];
    this.ticksX = Math.floor(graph.pixelToMM(this.width) / 1000);
    this.ticksY = Math.floor(graph.pixelToMM(this.height) / 1000);

    this.x = d3.scale.linear()
        .domain([0, d3.max(this.interval, function (d) {
            return d[0];
        })])
        .range([0, this.width]);

    this.y = d3.scale.linear()
        .domain([0, d3.max(this.interval, function (d) {
            return d[1];
        })])
        .range([this.height, 0]);



    //Rules group
    this.main = d3.select('#drawing').append('g')
        .attr('transform', 'translate(' + this.margin.left + ',' + this.margin.top + ')')
        .attr('width', this.width)
        .attr('height', this.height)
        .attr('class', 'rules');



    //X axis - bottom
    this.xAxis = d3.svg.axis()
        .scale(this.x)
        .orient('bottom')
    ;
    this.main.append('g')
        .attr('transform', 'translate(0,' + (height - this.margin.top - this.margin.bottom) + ')')
        .attr('class', 'main axis x')
        .call(this.xAxis)
    ;
    this.make_x_axis = function() {
        return d3.svg.axis()
            .scale(this.x)
            .orient("bottom")
            .ticks(this.ticksX)
    }

    //X axis - top
    this.xAxisTop = d3.svg.axis()
        .scale(this.x)
        .orient('top')
    ;
    this.main.append('g')
        .attr('transform', 'translate(0,0)')
        .attr('class', 'main axis x top')
        .call(this.xAxisTop)
    ;
    // this.make_x_axis_top = function() {
    //     return d3.svg.axis()
    //         .scale(this.x)
    //         .orient("top")
    //         .ticks(this.ticks)
    // }



    //Y axis - left
    this.yAxis = d3.svg.axis()
        .scale(this.y)
        .orient('left')
    ;
    this.main.append('g')
        .attr('transform', 'translate(0,0)')
        .attr('class', 'main axis y')
        .call(this.yAxis)
    ;
    this.make_y_axis = function() {
        return d3.svg.axis()
            .scale(this.y)
            .orient("left")
            .ticks(this.ticksY)
    }

    //Y axis - right
    this.yAxisRight = d3.svg.axis()
        .scale(this.y)
        .orient('right')
    ;
    this.main.append('g')
        .attr('transform', 'translate(' + this.width + ', 0)')
        .attr('class', 'main axis y right')
        .call(this.yAxisRight)
    ;


    //GRID
    this.main.append("g")
        .attr("class", "grid")
        .attr("transform", "translate(0," + this.height + ")")
        .call(this.make_x_axis()
            .tickSize(-this.height, 0, 0)
            .tickFormat(""))
    ;
    this.main.append("g")
        .attr("class", "grid")
        .call(this.make_y_axis()
            .tickSize(-this.width, 0, 0)
            .tickFormat(""))
    ;
};